import { ActionIcon, TextInput } from '@mantine/core';
import { IconSearch, IconX } from '@sloyd/icons';
import classnames from 'classnames';
import { Wrapper } from './Search.style';

export type SearchProps = {
  q: string;
  placeholder?: string;
  onSearch: (q: string) => void;
  onClear: () => void;
  flex?: boolean;
};

export function Search(props: SearchProps) {
  const { q, flex, placeholder = 'Search...' } = props;

  const className = classnames('Search-wrapper', { flex });

  return (
    <Wrapper className={className} data-testid='Search-wrapper'>
      <TextInput
        placeholder={placeholder}
        value={q}
        onChange={(event) => props.onSearch(event.target.value)}
        size='xs'
        leftSection={<IconSearch size={16} />}
        rightSection={
          q && (
            <ActionIcon onClick={props.onClear}>
              <IconX size={16} />
            </ActionIcon>
          )
        }
        aria-label='Search input'
      />
    </Wrapper>
  );
}

export default Search;
